import React, { useState,  useEffect, useRef} from 'react'; 
import axios from 'axios'; // Make sure to install axios if you haven't already
import { getBackendToken } from "../utils/authUtils";

function UsersList({ onUserSelect, initialValue = '' , isRequired = true,eleve=""}) {
  const [searchQuery, setSearchQuery] = useState('');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSearchQuery(initialValue);
  }, [initialValue]);
  
  const fetchUsers = async (query) => {
    setLoading(true);
    try {
      // Make a request to your backend to fetch users with query as a parameter
      const token = await getBackendToken();

      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/fetchUsers`, 
        {
        params: { q: query, eleve: eleve },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      // console.log("API Response:", response.data); // Log the API response
  
      setUsers(response.data); // Set fetched users directly
      // console.log(response.data)
    } catch (error) {
      console.error('Error fetching users:', error);
    }
    setLoading(false);
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.length >= 1) {
      fetchUsers(query); // Fetch users based on search query
    } else {
      setUsers([]); // Clear users if query is empty
    }
  };

  const handleUserSelect = (user) => {
    setSearchQuery(user.mail); // Set the input to the selected user's display name
    setUsers([]); // Clear the user list
    onUserSelect(user); // Trigger the onUserSelect callback
  };

  const [focusedIndex, setFocusedIndex] = useState(-1);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const wrapperRef = useRef(null);
  const listRef = useRef(null);

  const handleKeyDown = (e) => {
    if (!showSuggestions || users.length === 0) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setFocusedIndex((prev) => (prev + 1) % users.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setFocusedIndex((prev) => (prev - 1 + users.length) % users.length);
    } else if (e.key === "Enter" && focusedIndex !== -1) {
      handleUserSelect(users[focusedIndex]);
      setShowSuggestions(false);
    }
  };

  const handleInputChange = (e) => {
    handleSearch(e);
    setShowSuggestions(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
        setFocusedIndex(-1);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const listItems = listRef.current?.children;
    if (listItems && listItems[focusedIndex]) {
      listItems[focusedIndex].scrollIntoView({ block: "nearest" });
    }
  }, [focusedIndex]);
  return (
   
    <div ref={wrapperRef} className="w-full  mx-auto relative">
      <input
        type="text"
        placeholder={eleve === "student" ? "Rechercher un élève" : "Rechercher un utilisateur"}
        value={searchQuery}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        required={isRequired}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
      />

      {showSuggestions && users.length > 0 && (
  <ul
    ref={listRef}
    className="absolute z-10 w-full border border-gray-200 rounded-xl shadow-lg max-h-52 overflow-y-auto bg-white"
  >
    {users.map((user, index) => (
      <li
        key={user.id}
        onClick={() => {
          handleUserSelect(user);
          setShowSuggestions(false);
        }}
        className={`flex items-center gap-3 px-4 py-2.5 cursor-pointer transition-colors duration-150 border-b border-gray-100 last:border-0 ${
          index === focusedIndex ? "bg-blue-50" : "hover:bg-gray-50"
        }`}
      >
        <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-600 text-sm font-medium flex-shrink-0">
          {user.displayName?.charAt(0).toUpperCase()}
        </div>
        <div className="flex flex-col min-w-0">
          <span className="text-sm font-medium text-gray-800 truncate">{user.displayName}</span>
          <span className="text-xs text-gray-400 truncate">{user.mail}</span>
          {eleve === "student" && user.officeLocation && (
            <span className="text-xs text-blue-400">{user.officeLocation}</span>
          )}
        </div>
      </li>
    ))}
  </ul>
)}

      {loading && (
        <p className="text-sm text-gray-500 mt-2 animate-pulse">Chargement...</p>
      )}
    </div>

  );
}

export default UsersList;

